import { Pipe, PipeTransform } from '@angular/core';
import { emojiHelper } from '../emojies/emoji.helper.js';

@Pipe({
	name: 'replaceEmojis',
	pure: true,
	standalone: false
})
export class ReplaceEmojisPipe implements PipeTransform {
	constructor() {}

	transform(text?: string | null): string | undefined {
		if (!text) {
			return undefined;
		}

		return emojiHelper.replaceTextWithEmojis(text);
	}
}
